import PhilosophyPc from './PhilosophyPc';
import PhilosophySp from './PhilosophySp';

class PhilosophyCommon {
  constructor(pageApp) {
    this._pageApp = pageApp;

    setTimeout(() => {
      if (pageApp.viewMode === 'sp') {
        new PhilosophySp(pageApp);
      } else {
        new PhilosophyPc(pageApp);
      }
    }, 0);
  }
}

export default PhilosophyCommon;
